// extracted by mini-css-extract-plugin
module.exports = {"ProcessOptimizationServices":"ProcessOptimizationServices_ProcessOptimizationServices__Y5IAC"};